import { translate } from '../../../Services/translation';
import { mixed, object, ref, string } from 'yup';

const requiredTranslation = translate('validation.required');

export const registerUserValidationSchema = object().shape({
  username: string()
    .nullable()
    .required(requiredTranslation)
    .email(translate(`validation.email`)),
  lastName: string().nullable().required(requiredTranslation),
  firstName: string().nullable().required(requiredTranslation),
  address: string()
    .nullable()
    .required(requiredTranslation)
    .max(
      36,
      translate('validation.too-long')
        .replace(
          '{0}',
          translate('checkout.customerinfo.address').replace('*', '')
        )
        .replace('{1}', '36')
    ),
  zipCode: string()
    .nullable()
    .required(requiredTranslation)
    .max(
      10,
      translate('validation.too-long')
        .replace(
          '{0}',
          translate('checkout.customerinfo.zipcode').replace('*', '')
        )
        .replace('{1}', '10')
    ),
  city: string()
    .nullable()
    .required(requiredTranslation)
    .max(
      36,
      translate('validation.too-long')
        .replace(
          '{0}',
          translate('checkout.customerinfo.city').replace('*', '')
        )
        .replace('{1}', '36')
    ),
  country: mixed()
    .nullable()
    .required(requiredTranslation)
    .notOneOf([''], requiredTranslation),
  phone: string().nullable().required(requiredTranslation),
  password: string().nullable().required(requiredTranslation),
  confirmPassword: string()
    .nullable()
    .required(requiredTranslation)
    .oneOf(
      [ref('password'), null],
      translate('login.confirm-password.must-match')
    ),
});
